<template lang="pug">
  #GoTop
    .fixed_box_li(@click.stop="showFlag = true")
      img(src="@/assets/img/float_wechat.png")
    .fixed_box_li(@click="coverFn")
      img(src="@/assets/img/float_contactus.png")
    .fixed_box_li(@click="GoTop")
      img(src="@/assets/img/float_top.png")
    .cover_global(v-if="showFlag")
      .box_ewm.container
        i.el-icon-close(@click.stop="showFlag = false")
        img(src="@/assets/img/bottom_wxgzh.png")
        p 扫描二维码关注我们
</template>
<script>
export default {
  name: "GoTop2",
  data() {
    return {
      showFlag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    coverFn() {
      this.$emit('change', true);
    }
  },
};
</script>
<style lang="scss" scoped>
#GoTop {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 99999999;
  .fixed_box_li {
    position: relative;
    background: #00387D;
    box-shadow: 0px 0px 6px rgba(0,56,125,0.58);
    margin-top: 5px;
    cursor: pointer;
    text-align: center;
    padding: 15px;
    img {
      width: 35px;
      height: 30px;
    }
    p {
      font-size: 12px;
      color: white;
      font-weight: 400;
      line-height: 24px;
    }
    &:nth-child(1) {
      margin-top: 0;
    }
  }

  .cover_global {
    z-index: 999999999;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    .box_ewm {
      position: absolute;
      right: 50%;
      top: 50%;
      transform: translate(50%, -50%);
      // width: 90%;
      background: #FFFFFF;
      box-shadow: 0px 0px 6px rgba(0,56,125,0.58);
      padding: 50px 0 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 50%;
        height: auto;
        display: inline-block;
      }
      p {
        font-size: 12px;
        color: #666666;
      }

      i {
        position: absolute;
        top: 13px;
        right: 13px;
        font-size: 20px;
        color: #8994A7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop2.vue